export function LogoIcon({...props}) {
  return (
    <svg
      aria-label='PR TIMES'
      width='101'
      height='20'
      viewBox='0 0 101 20'
      fill='none'
      {...props}
    >
      <g>
        <path
          d='M31.2188 1.75464V5.19323H35.9171V19.1997L39.4036 15.2387V5.19323L44.1209 5.19406V1.75464H31.2188Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.1309 3.31444C10.0298 2.30518 8.53042 1.70508 6.9128 1.70508H0.0273438V17.7268H3.48164V13.0657H6.9128C8.53042 13.0657 10.0307 12.4647 11.1309 11.453C12.2344 10.4479 12.913 8.99969 12.913 7.39694V7.38124C12.913 5.7727 12.2377 4.32122 11.1309 3.31444ZM9.45289 7.3862C9.44628 8.52027 8.99744 9.02614 8.46264 9.30305C7.92206 9.57747 7.27153 9.58243 6.9128 9.58243L3.48164 9.58161V5.19161H6.9128C7.24839 5.18996 7.89891 5.19575 8.44529 5.47017C8.98835 5.74791 9.44628 6.25543 9.45289 7.3862Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M98.8884 9.02896C97.8841 8.13046 96.5963 7.9949 95.1217 7.99408L92.9866 7.9949C92.6527 7.99573 92.1418 7.98085 91.7376 7.80644C91.3351 7.62376 91.0392 7.33777 91.0309 6.67237C91.0384 5.90364 91.3434 5.57797 91.7286 5.3862C92.1187 5.19774 92.6097 5.18865 92.9197 5.18947H92.9569L99.2521 5.1903V1.70459H92.9866C91.5608 1.70459 90.2275 2.04266 89.2314 2.93786C88.2395 3.81734 87.5923 5.25395 87.5898 6.67154L87.5907 6.67237C87.5923 8.08665 88.1792 9.55301 89.1752 10.4375C90.1812 11.3351 91.4359 11.4583 92.9866 11.4575H95.1754C95.4507 11.4575 95.9309 11.4641 96.3211 11.6302C96.7071 11.8038 97.0046 12.084 97.0121 12.7519C97.0046 13.5338 96.6815 13.867 96.2822 14.0629C95.878 14.2546 95.3862 14.2612 95.1142 14.2596H88.2726V17.7263H95.1217C96.5475 17.7263 97.885 17.3733 98.8777 16.4848C99.8688 15.6086 100.512 14.1951 100.526 12.7907V12.7519C100.524 11.331 99.882 9.9101 98.8884 9.02896Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M49.8708 17.7267V-0.000244141L46.2148 4.09879V17.7267H49.8708Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.5473 12.6884C24.3194 12.4123 25.0236 11.9941 25.6122 11.4527C26.714 10.4475 27.3926 8.99935 27.3926 7.3966V7.38173C27.3926 5.77236 26.7181 4.32088 25.6113 3.3141C24.512 2.30401 23.0109 1.70557 21.3933 1.70557H14.5078V17.7264H17.9629V11.2576L23.5647 17.7364H27.8787L27.6398 17.4578L23.5473 12.6884ZM23.9342 7.38668C23.9267 8.52076 23.4787 9.0258 22.9431 9.30271C22.4025 9.57714 21.7512 9.58292 21.3933 9.58209H17.9629V5.19128H21.3933C21.728 5.18962 22.3786 5.19541 22.9258 5.46983C23.4688 5.74839 23.9267 6.25344 23.9342 7.38668Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M72.8593 2.92947C72.05 3.66017 71.5938 4.65703 71.5946 5.7349L71.5938 13.7263C71.5938 14.8017 72.05 15.8035 72.8617 16.5276C73.6478 17.2534 74.6058 17.7377 75.8837 17.7377H86.0739V14.2826H75.5506C75.42 14.2768 75.3588 14.2603 75.2225 14.1471C75.1183 14.0503 75.0439 13.9123 75.0431 13.7263V11.4697H84.5083L84.5265 8.01462H75.0431V5.76714C75.0431 5.58198 75.12 5.4365 75.2266 5.34393C75.3588 5.23234 75.4175 5.21829 75.5581 5.21002H86.0739V1.72266H75.8879C74.5992 1.72596 73.6495 2.21117 72.8593 2.92947Z'
          fill='#294C7A'
        />
      </g>
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M64.6835 1.74561H56.6706C55.5919 1.74561 54.5868 2.20105 53.861 3.01028C53.132 3.79636 52.646 4.75437 52.6484 6.03227V17.7235H56.1127V5.6909C56.1185 5.56195 56.135 5.49995 56.2482 5.36439C56.3449 5.26107 56.4846 5.18502 56.6706 5.18502H58.933V17.7061L62.3964 17.7243V5.18502H64.6521C64.8348 5.18502 64.9811 5.2619 65.0762 5.36935C65.1869 5.50161 65.2018 5.55947 65.2101 5.69999L65.2092 17.7235H68.7049V6.02814C68.7032 4.7428 68.2164 3.79554 67.4964 3.00697C66.7632 2.20105 65.763 1.74561 64.6835 1.74561Z'
          fill='#294C7A'
        />
      </g>
    </svg>
  );
}

export function WhiteLogoIcon() {
  return (
    <svg
      aria-label='PR TIMES'
      width='121'
      height='24'
      viewBox='0 0 121 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.5534 2.10983V6.25034H43.2108V23.1138L47.4077 18.3457V18.2685V6.25034L53.0875 6.25113V2.10983H37.5534Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.3485 8.89319C11.3404 10.2583 10.8005 10.8671 10.1562 11.2008C9.50514 11.5313 8.722 11.5376 8.29063 11.5368L4.15928 11.536V6.25038H8.29063C8.69388 6.2488 9.47721 6.25552 10.1356 6.58599C10.7888 6.92081 11.3404 7.53099 11.3485 8.89319ZM13.3683 3.99079C12.0433 2.77516 10.2382 2.05338 8.29063 2.05338H0V21.3424H4.15928V15.7314H8.29063V15.7306C10.2382 15.7306 12.0441 15.0073 13.3691 13.7893C14.6975 12.579 15.5145 10.8357 15.5137 8.90583V8.88766C15.5145 6.95024 14.7015 5.20325 13.3683 3.99079Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M119.029 10.8711L119.029 10.8707C117.819 9.78923 116.268 9.62567 114.494 9.62488L111.923 9.62567C111.521 9.62646 110.905 9.60928 110.418 9.3989C109.934 9.17944 109.578 8.83435 109.568 8.03414C109.577 7.1085 109.944 6.71639 110.408 6.48508C110.877 6.25831 111.469 6.24705 111.843 6.24883H111.887L119.466 6.24962V2.05301H111.923C110.205 2.05301 108.601 2.45993 107.402 3.53748C106.208 4.59606 105.428 6.32547 105.425 8.03256L105.426 8.03414C105.428 9.73708 106.135 11.5022 107.333 12.5668C108.545 13.6477 110.056 13.7964 111.923 13.7956H114.536H114.557C114.889 13.7948 115.468 13.8027 115.937 14.0034C116.402 14.2122 116.76 14.5492 116.769 15.3536C116.76 16.2944 116.371 16.696 115.89 16.9323C115.404 17.1622 114.812 17.1709 114.483 17.1689H106.452H106.248V21.3424H114.494C116.21 21.3424 117.82 20.9179 119.016 19.8479C120.208 18.7932 120.983 17.0913 121 15.4006V15.3536C120.998 13.6427 120.225 11.9321 119.029 10.8711Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55.611 5.01282V21.3428H60.0129V0L55.611 4.93479V5.01282Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.776 8.89357C28.7677 10.2587 28.2272 10.8671 27.5829 11.2012C26.9317 11.5308 26.1481 11.5383 25.7169 11.5368H21.5866V6.25036H25.7169C26.1198 6.24878 26.9033 6.2555 27.5619 6.58598C28.2155 6.92159 28.7677 7.52999 28.776 8.89357ZM28.3104 15.2771C29.2403 14.944 30.0878 14.4405 30.7958 13.7892C32.1228 12.5788 32.9406 10.8357 32.9406 8.90581V8.88764C32.9406 6.95023 32.1278 5.20324 30.7948 3.99077C29.4712 2.77436 27.6643 2.05356 25.7169 2.05356H17.4269V21.3424H21.5866V13.5546L28.3312 21.355H33.5257L33.2377 21.0186L28.3104 15.2771Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M87.6914 3.52716C86.7177 4.40678 86.1679 5.60679 86.1685 6.90459L86.1679 16.5259C86.1679 17.8213 86.7169 19.0273 87.6946 19.8988C88.6407 20.7729 89.7946 21.3554 91.3329 21.3554H91.3428H103.602V17.1963H103.397H90.9313C90.7738 17.1888 90.7017 17.1692 90.5369 17.0329C90.4118 16.9164 90.3208 16.7505 90.3201 16.5259V13.809H101.717L101.739 9.64992H90.3201V6.94331C90.3201 6.72108 90.4133 6.54587 90.5419 6.43407C90.7017 6.29974 90.7714 6.28216 90.9404 6.27248H103.602V2.0741H91.3377C89.7871 2.07805 88.6429 2.66216 87.6914 3.52716Z'
        fill='var(--color-white)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77.8506 2.10199H68.203C66.9044 2.1012 65.6944 2.64995 64.8208 3.62498C63.9426 4.57136 63.3583 5.72457 63.3607 7.26276V21.3392H67.531V21.1348V6.85229C67.5382 6.69643 67.5584 6.62256 67.6944 6.45939C67.8111 6.33416 67.9788 6.24309 68.203 6.2423H70.9264L70.9272 21.3177L75.0972 21.34V6.2423H77.8128C78.032 6.2423 78.2093 6.33593 78.3226 6.46473C78.4569 6.62414 78.4741 6.69327 78.484 6.86276L78.4832 21.3392H82.6926V7.25802C82.6904 5.71113 82.1038 4.57057 81.2368 3.62063C80.3541 2.64995 79.1501 2.1012 77.8506 2.10199Z'
        fill='var(--color-white)'
      />
    </svg>
  );
}

export function SocialIcon() {
  return (
    <svg
      aria-hidden='true'
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
    >
      <g>
        <path
          d='M15 0C13.343 0 12 1.343 12 3C12 3.188 12.019 3.376 12.055 3.561L4.939 7.711C4.397 7.252 3.71 7 3 7C1.343 7 0 8.343 0 10C0 11.657 1.343 13 3 13C3.709 12.999 4.395 12.746 4.936 12.287L12.055 16.439C12.019 16.624 12 16.812 12 17C12 18.657 13.343 20 15 20C16.657 20 18 18.657 18 17C18 15.343 16.657 14 15 14C14.29 14.001 13.604 14.253 13.063 14.713L5.945 10.561C5.981 10.376 6 10.188 6 10C6 9.812 5.981 9.624 5.945 9.439L13.061 5.289C13.603 5.748 14.29 6 15 6C16.657 6 18 4.657 18 3C18 1.343 16.657 0 15 0Z'
          fill='black'
        />
      </g>
    </svg>
  );
}

export function WebIcon() {
  return (
    <svg
      aria-hidden='true'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <g>
        <path
          d='M2 6H16V16H2V6ZM10 2H15C15.552 2 16 2.448 16 3C16 3.552 15.552 4 15 4H10C9.448 4 9 3.552 9 3C9 2.448 9.448 2 10 2ZM6 2C6.552 2 7 2.448 7 3C7 3.552 6.552 4 6 4C5.448 4 5 3.552 5 3C5 2.448 5.448 2 6 2ZM3 2C3.552 2 4 2.448 4 3C4 3.552 3.552 4 3 4C2.448 4 2 3.552 2 3C2 2.448 2.448 2 3 2ZM2 0C0.895 0 0 0.895 0 2V16C0 17.093 0.907 18 2 18H16C17.093 18 18 17.093 18 16V2C18 0.895 17.105 0 16 0H2Z'
          fill='black'
        />
      </g>
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg
      aria-hidden='true'
      width='12'
      height='10'
      viewBox='0 0 12 10'
      fill='none'
    >
      <path
        d='M0.570312 3.68018L4.57031 8.68018L10.5703 0.680176'
        stroke='black'
        strokeWidth='1.5'
        strokeMiterlimit='2'
      />
    </svg>
  );
}

export function PulldownArrowIcon() {
  return (
    <svg aria-hidden='true' width='9' height='6' viewBox='0 0 9 6' fill='none'>
      <path
        d='M4.88672 5.5L0.886719 0.5L8.88672 0.5L4.88672 5.5Z'
        fill='black'
      />
    </svg>
  );
}

export function MailIcon() {
  return (
    <svg
      aria-hidden='true'
      width='20'
      height='16'
      viewBox='0 0 20 16'
      fill='none'
    >
      <g>
        <path
          d='M2 5.002L10 10L18 5.002V14H2V5.002ZM2 2H18V3.002L10 8L2 3.002V2ZM2 0C0.895 0 0 0.895 0 2V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V2C20 0.895 19.105 0 18 0H2Z'
          fill='black'
        />
      </g>
    </svg>
  );
}

export function DesktopIcon() {
  return (
    <svg
      aria-hidden='true'
      width='22'
      height='20'
      viewBox='0 0 22 20'
      fill='none'
    >
      <g clipPath='url(#clip0_2857_31416)'>
        <g>
          <g>
            <path
              d='M2 2H20V14H2V2ZM2 0C0.895 0 0 0.895 0 2V14C0 15.105 0.895 16 2 16H9V18H7V20H15V18H13V16H20C21.105 16 22 15.105 22 14V2C22 0.895 21.105 0 20 0H2Z'
              fill='black'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2857_31416'>
          <rect width='22' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MobileIcon() {
  return (
    <svg
      aria-hidden='true'
      width='14'
      height='22'
      viewBox='0 0 14 22'
      fill='none'
    >
      <g>
        <path
          d='M12 20H2V2H12V20ZM11.5 0H2.5C1.12 0 0 1.12 0 2.5V19.5C0 20.88 1.12 22 2.5 22H11.5C12.88 22 14 20.88 14 19.5V2.5C14 1.12 12.88 0 11.5 0Z'
          fill='black'
        />
      </g>
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      aria-hidden='true'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
    >
      <g>
        <path
          d='M2 14.5107L14 2.51074'
          stroke='white'
          strokeWidth='1.97326'
          strokeMiterlimit='1'
        />
      </g>
      <g>
        <path
          d='M2 2.50977L14 14.5098'
          stroke='white'
          strokeWidth='1.97326'
          strokeMiterlimit='1'
        />
      </g>
    </svg>
  );
}
